export default {
  id: 65,
  title: 'Target #65 - Max Volume',
  url: 'https://cssbattle.dev/play/65',
  colors: ['#191919', '#5DBCF9'],
  solution:
    '<a a><a b><a c><style>body{background:#191919}a{position:fixed}a[a]{top:125;left:75;width:75;height:50;background:#5DBCF9;border-radius:10px}a[b]{top:50;left:50;height:50;border:75px solid transparent;border-right-color:#5DBCF9}a[c]{top:100;left:175;width:80;height:80;border:10px solid #5DBCF9;border-radius:50%;box-shadow:0 0 0 15px #191919,0 0 0 25px #5DBCF9,0 0 0 40px #191919,0 0 0 50px #5DBCF9;clip-path:inset(-50px -50px -50px 50px)}</style>',
}
